export const ApprovalActionType = {
  GET_FEATURED_POSTS_LIST: 'GET_FEATURED_POSTS_LIST',
  GET_FEATURED_POSTS_LIST_APPROVED: 'GET_FEATURED_POSTS_LIST_APPROVED',
  APPROVE_POST: 'APPROVE_POST',
  FIRSTTIME_APPROVED_USER_FULFILLED: 'FIRSTTIME_APPROVED_USER_FULFILLED',
  REAPPLY_APPROVED_USER_FULFILLED: ' REAPPLY_APPROVED_USER_FULFILLED',
  PAST_APPROVAL_REQUESTS_FULFILLED: 'PAST_APPROVAL_REQUESTS_FULFILLED',
};
